export default () => {
    return (scope, element) => {
        let focusListener = () => {
            scope.hasFocus = true;
            scope.$digest();
        };

        let blurListener = () => {
            scope.hasFocus = false;
            scope.$digest();
        };
        element[0].addEventListener('focus', focusListener, true);
        element[0].addEventListener('blur', blurListener, true);
    };
}
